"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUnifiedNetworkName = exports.getNetworkByNetworkName = exports.isNetworkAggregationExcluded = exports.aggregationExcludedNetwork = void 0;
const common_enums_1 = require("@klear/common-enums");
exports.aggregationExcludedNetwork = common_enums_1.Networks.YOUTUBE;
function isNetworkAggregationExcluded(network) {
    return network === exports.aggregationExcludedNetwork;
}
exports.isNetworkAggregationExcluded = isNetworkAggregationExcluded;
function getNetworkByNetworkName(network) {
    return network === 'insta' ? common_enums_1.Networks.INSTAGRAM : network;
}
exports.getNetworkByNetworkName = getNetworkByNetworkName;
function getUnifiedNetworkName(network) {
    switch (network) {
        case common_enums_1.Networks.BLOG:
            return common_enums_1.Networks.BLOG;
        case common_enums_1.Networks.FACEBOOK:
        case common_enums_1.Networks.FACEBOOK_STORIES:
            return common_enums_1.Networks.FACEBOOK;
        case common_enums_1.Networks.INSTAGRAM:
        case common_enums_1.Networks.INSTA_STORIES:
        case common_enums_1.Networks.INSTAGRAM_BUSINESS:
        case common_enums_1.Networks.INSTAGRAM_CREATOR:
            return common_enums_1.Networks.INSTAGRAM;
        case common_enums_1.Networks.TIKTOK:
            return common_enums_1.Networks.TIKTOK;
        case common_enums_1.Networks.TWITTER:
            return common_enums_1.Networks.TWITTER;
        case common_enums_1.Networks.TWITCH:
            return common_enums_1.Networks.TWITCH;
        case common_enums_1.Networks.YOUTUBE:
            return common_enums_1.Networks.YOUTUBE;
    }
    return null;
}
exports.getUnifiedNetworkName = getUnifiedNetworkName;
//# sourceMappingURL=networks.js.map